import React, { useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'

const WCRightsInformationOnline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        ids
    } = route.params

    console.log(essUserOnBoardingKey)

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postWCRightsOnline, loading } = useFormsStore()

    // const canvasRef = useRef(null)
    const [hasDrawn, setHasDrawn] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')

    const data = {
        entityId: personalstore?.personalData?.entityId,
        essUserKey: intializestore?.initializeData?.userkey,
        essObKey: essUserOnBoardingKey,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        completeOnline: true,
        name: personalstore?.personalData?.firstName + " " + personalstore?.personalData?.lastName,
        sign: signatureDataURL
    }

    const handlesubmit = async () => {
        const response = await postWCRightsOnline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'WC Rights And Duties Form For Karns'}
                    />
                </View>
            </View>
            <ScrollView>
                <Card style={{ fontFamily: " Arial, sans-serif", fontSize: "11px" }}>
                    <div style={{ margin: '40px' }}>
                        <p style={{ textAlign: 'end' }}>
                            <strong>Notification to Employees of Their Rights and Duties<br />Under the PA Workers' Compensation Act<br />Section 306 (f.1)(1)(i)</strong>
                        </p>

                        <hr style={{ border: '1.5px solid black', marginTop: '-13px' }} />

                        <p>
                            The Pennsylvania Workers’ Compensation Act requires that employees be given written notice of
                            their rights and duties under Sec. 306 (f.1)(1)(i) of the Act if a list of designated health care
                            providers is established by the employer. The text of this section is provided on the next page.
                        </p>
                        <p>
                            If you are viewing this electronically, your electronic signature will be your acknowledgement that
                            you have been provided with your rights and duties; otherwise, you must acknowledge this with
                            your signature and return it to your employer. You may keep a copy for your records.
                        </p>

                        <p style={{ fontSize: 'large' }}>
                            Rights and Duties
                        </p>

                        <hr style={{ border: '1px solid black', marginTop: '-16px' }} />

                        <p>
                            As an employee of the commonwealth working at a location where a list of designated health care
                            providers has been established and posted, you have the right to seek emergency medical treatment
                            from any provider; for post-emergency and other injuries, you must obtain treatment for work-related injuries and illnesses from a designated health care provider for 90 days. The penalty for not
                            using a designated health care provider is that the commonwealth is not liable for the medical bills
                            incurred. Specific rights and duties are:
                        </p>


                        <ul>
                            <li>The duty to obtain treatment for work-related injuries and illnesses from one or more of the designated health care providers for 90 days from the date of the first visit to a designated provider.</li>
                            <li>The right to seek emergency medical treatment from any provider, but subsequent non-emergency treatment shall be by a designated provider for the remainder of the 90-day period.</li>
                            <li>The right to have all reasonable medical supplies and treatment related to the injury paid for by your employer as long as treatment is obtained from a designated provider during the 90-day period.</li>
                            <li>The right, during this 90-day period, to switch from one designated health care provider to another designated provider.</li>
                            <li>The right to seek treatment from a provider if you are referred to that provider by a designated provider.</li>
                            <li>The right to an additional opinion from a provider of your choice when invasive surgery is prescribed by the designated provider.</li>
                            <li>The right to seek treatment or medical consultation from a non-designated provider during the 90-day period, but the services shall be at your expense for the applicable 90 days.</li>
                            <li>The right to seek treatment from any health care provider after the 90-day period has ended.</li>
                            <li>The duty to notify your employer of treatment by a non-designated provider (after the 90 day period) within 5 days of the first visit to that provider. The employer may not be required to pay for treatment rendered by a non-designated provider prior to receiving this notification.</li>
                        </ul>


                        <p>
                            I acknowledge that I have been informed of my rights and duties under Sec. 306 (f.1)(1)(i) and that
                            I understand them to the extent they are explained above.
                        </p>

                        <div>
                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '40%' }}></td>
                                        <td style={{ width: '40%' }}></td>
                                        <td style={{ width: '20%' }}></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '40%' }}>
                                            <p>{personalstore?.personalData?.firstName + " " + personalstore?.personalData?.lastName}</p>
                                            <div style={{ width: '75%', borderTop: '1px solid black', }}></div>
                                            <p style={{}}>Employee’s Printed Name</p>
                                        </td>
                                        <td style={{ width: "80%" }}>
                                            <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                                            <p>Employee Signature
                                                <br />
                                            </p>
                                        </td>
                                        <td style={{ width: "40%", paddingLeft: "10px" }}>
                                            <p style={{ textAlign: "center" }}> {moment().format("MM/DD/YYYY")} </p>
                                            <div style={{ borderBottom: '1px solid black', width: '75%', }}></div>
                                            <p style={{ textAlign: "center" }}>Date</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p style={{ margin: '20px', textAlign: 'center', display: 'flex' }}>
                            <strong>If you have any questions, ask your human resources office or call the Bureau of Workers’ Compensation at 800.482.2383</strong>
                        </p>

                        <p>
                            <strong>Text of Section 306 (f.1)(1)(i):</strong> The employer shall provide payment in accordance with this
                            section for reasonable surgical and medical services, services rendered by physicians or other health
                            care providers, including an additional opinion when invasive surgery may be necessary, medicines
                            and supplies, as and when needed. Provided an employer establishes a list of at least six designated
                            health care providers, no more than four of whom may be a coordinated care organization and no
                            fewer than three of whom shall be physicians, the employee shall be required to visit one of the
                            physicians or other health care providers so designated and shall continue to visit the same or
                            another designated physician or health care provider for a period of ninety (90) days from the date
                            of the first visit...
                        </p>
                    </div>
                </Card>
                {loading ? <ActivityIndicator /> :
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() =>
                                navigation.navigate('OnboardingForms', {
                                    essUserOnBoardingFormKey,
                                    essUserOnBoardingKey,
                                    values
                                })
                            }
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>}

            </ScrollView >
        </>
    )
}
export default WCRightsInformationOnline
